/** Aligns API status strings with the normalized keys used in filters and UI. */
export function normalizeServiceOrderStatus(status: string): string {
  const key = status.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");
  if (key === "open") return "pending";
  if (key === "inprogress") return "in_progress";
  return key;
}
